import { Controller } from "stimulus";

// Collapsible sidebar section. Remembers its open/closed state per key in
// localStorage so the choice survives page reloads.
export default class extends Controller {
  static targets = ["content", "icon"];
  static values = { key: String, collapsed: Boolean };

  connect() {
    const stored = this.storageKey && localStorage.getItem(this.storageKey);
    if (stored !== null && stored !== undefined && stored !== "") {
      this.collapsedValue = stored === "1";
    }
    this.render();
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue;
    if (this.storageKey) {
      localStorage.setItem(this.storageKey, this.collapsedValue ? "1" : "0");
    }
    this.render();
  }

  render() {
    this.contentTarget.classList.toggle("hidden", this.collapsedValue);
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", this.collapsedValue);
    }
  }

  get storageKey() {
    return this.keyValue ? `ticket_sidebar_collapse_${this.keyValue}` : null;
  }
}
